import type { ReactNode } from 'react'
import { Logo } from '../Logo/Logo'
import { Tag } from '../Tag/Tag'
import './GiftCard.css'

export type GiftCardFace = 'front' | 'back'

export interface GiftCardProps {
  face?: GiftCardFace
  amount?: string
  tagline?: ReactNode
  beneficiary?: string
  validUntil?: string
  serial?: string
}

/**
 * Physical gift card mockup, recto (`face="front"`) or verso (`face="back"`).
 * Both faces share the same outer box (fixed size, `.azoya-gift-card`) so a
 * front/back pair always renders at identical dimensions — only the inner
 * content differs, positioned absolutely to fill the card edge to edge.
 */
export function GiftCard({
  face = 'front',
  amount = '50€',
  tagline,
  beneficiary = '—',
  validUntil,
  serial,
}: GiftCardProps) {
  return (
    <div className="azoya-gift-card">
      {face === 'front' ? (
        <>
          <div className="azoya-gift-card-frame" />
          <div className="azoya-gift-card-logo">
            <Logo size={30} />
          </div>
          <div className="azoya-gift-card-label">Carte Cadeau</div>
          <div className="azoya-gift-card-amount">{amount}</div>
          {tagline && (
            <div className="azoya-gift-card-tag">
              <Tag variant="coral">{tagline}</Tag>
            </div>
          )}
        </>
      ) : (
        <div className="azoya-gift-card-back-content">
          <div className="azoya-gift-card-back-row azoya-gift-card-back-labels">
            <span>Bénéficiaire</span>
            <span>Valable jusqu'au</span>
          </div>
          <div className="azoya-gift-card-back-row azoya-gift-card-back-value">
            <span>{beneficiary}</span>
            <span>{validUntil}</span>
          </div>
          <div className="azoya-gift-card-spacer" />
          <div className="azoya-gift-card-barcode" />
          <div className="azoya-gift-card-back-row azoya-gift-card-back-footer">
            <span>{serial}</span>
            <Logo size={16} />
          </div>
        </div>
      )}
    </div>
  )
}
